module.exports = __webpack_public_path__ + "static/media/trophy_icon.72d3bae5.png";